import { render } from "./WebsRevenueStackedBarChart.vue?vue&type=template&id=4601eccd"
import script from "./WebsRevenueStackedBarChart.vue?vue&type=script&lang=js"
export * from "./WebsRevenueStackedBarChart.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__